import * as React from "react";
import { Datagrid, TextField, TopToolbar, ExportButton, useDataProvider, FunctionField } from "react-admin";
import { IconButton, Tooltip } from "@material-ui/core";
import moment from "moment";
import { ExcelExport } from "../../Helper/ExportExcel";
import { CustomDateField } from "../../Components/CustomDateField";
import { FilterInputType, FilterTypes } from "../../Enums/FilterTypes";
import FilterToolbar from "../../Components/FiltersToolbar/FilterToolbar";
import { useAuth } from "@airborne/react-admin";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
import OldDataFileList from "./OldDataFileList";
import { AttachFile } from "@material-ui/icons";

const OldDataExportList = props => {
  const { user } = useAuth();
  const dataProvider = useDataProvider();
  const [customers, setCustomers] = React.useState<any>([]);
  const [requirementCategories, setRequirementCategories] = React.useState<any>([]);
  const [openFiles, setOpenFiles] = React.useState(false);
  const [selectedRequestId, setSelectedRequestId] = React.useState<string | null>(null);

  const filters = (
    <FilterToolbar
      dataSource={[
        {
          source: "customerID",
          inputType: FilterInputType.Select,
          label: "Customer",
          filterTypeChangeDisable: true,
          filterType: FilterTypes.Equals,
          choices: customers,
          optionValue: "customerID",
          optionText: "customerName",
          resettable: false,
        },
        {
          source: "customerPO",
          inputType: FilterInputType.Text,
          label: "Customer PO",
          filterTypeChangeDisable: true,
        },
        {
          source: "refNo",
          inputType: FilterInputType.Text,
          label: "Ref No",
          filterTypeChangeDisable: true,
        },
        {
          source: "acRegistration",
          inputType: FilterInputType.Text,
          label: "AC Registration",
          filterTypeChangeDisable: true,
        },
        {
          source: "partNumber",
          inputType: FilterInputType.Text,
          filterType: FilterTypes.Contains,
          label: "Requested PN",
          filterTypeChangeDisable: true,
        },
        {
          source: "servPartNo",
          inputType: FilterInputType.Text,
          filterType: FilterTypes.Contains,
          label: "Serviceable PN",
          filterTypeChangeDisable: true,
        },
        {
          source: "servSerialNo",
          inputType: FilterInputType.Text,
          filterType: FilterTypes.Contains,
          label: "Serviceable SN",
          filterTypeChangeDisable: true,
        },
        {
          source: "unServPartNo",
          inputType: FilterInputType.Text,
          filterType: FilterTypes.Contains,
          label: "Core Unit PN",
          filterTypeChangeDisable: true,
        },
        {
          source: "unServSerialNo",
          inputType: FilterInputType.Text,
          filterType: FilterTypes.Contains,
          label: "Core Unit SN",
          filterTypeChangeDisable: true,
        },
        {
          source: "melCategory",
          inputType: FilterInputType.Select,
          label: "Requirement Category",
          filterTypeChangeDisable: true,
          filterType: FilterTypes.Equals,
          choices: requirementCategories,
          optionValue: "melCategory",
          optionText: "melCategory",
          resettable: false,
        },
        {
          source: "requestedDeliveryDate",
          inputType: FilterInputType.Date,
          label: "Requested Delivery Date From",
          filterTypeChangeDisable: true,
          filterType: FilterTypes.GreaterThanOrEqual,
        },
        {
          source: "requestedDeliveryDate",
          inputType: FilterInputType.Date,
          label: "Requested Delivery Date To",
          filterTypeChangeDisable: true,
          filterType: FilterTypes.LessThanOrEqual,
        },
      ].filter(item => (user?.isCustomer ? item.source !== "customerID" : true))}
    />
  );

  const ListActions = props => (
    <TopToolbar>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  React.useEffect(() => {
    if (!user?.isCustomer) {
      GetCustomerList();
    }
    GetRequirementCategoryList();
  }, []);

  const GetCustomerList = () => {
    dataProvider
      .getList("mastercustomers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerName", order: "ASC" },
        filter: {},
      })
      .then(response => {
        let dataLength: number = response?.data?.length;
        if (dataLength > 0) {
          let data = response.data;
          let customerList = data.map?.(x => {
            return { customerID: Number(x.id), customerName: x.customerName };
          });
          setCustomers(customerList);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const GetRequirementCategoryList = () => {
    dataProvider
      .getList("mastertypes", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "value", order: "ASC" },
        filter: {},
      })
      .then(response => {
        let dataLength: number = response?.data?.length;
        if (dataLength > 0) {
          let data = response.data;
          let requirementCategoryList = data.map?.(x => {
            return { melCategoryId: x.text, melCategory: x.text };
          });
          setRequirementCategories(requirementCategoryList);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const exporter = records => {
    const data = records.map(record => ({
      "Ref No": record.refNo,
      "XO Number": record.tamesExchangeNo,
      Customer: record.customerName,
      "Customer PO": record.customerPO,
      "Requirement Category": record.melCategory,
      "AC Registration": record.acRegistration,
      "Part No": record.partNumber,
      Destination: record.destination,
      "Request Date": record.requestDate,
      "Requested Delivery Date": record.requestedDeliveryDate,
      "Request Status": record.rStatus,
      "SVC Part No": record.servPartNo,
      "SVC Serial No": record.servSerialNo,
      "SVC AWB": record.servAWB,
      "SVC Send Date": record.servSendDate,
      "SVC Estimated Date": record.servEstimatedDate,
      "UNSVC Part No": record.unServPartNo,
      "UNSVC Serial No": record.unServSerialNo,
      "UNSVC AWB": record.unServAWB,
      "UNSVC Send Date": record.unServSendDate,
      "UNSVC Estimated Date": record.unServEstimatedDate,
      Serviceable: record.servicable,
      Unserviceable: record.unServicable,
      "Core Unit AC Reg": record.unServicableACReg,
      "Serviceable Shipped On Time": record.shippedOnTime,
    }));

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Old Export Data List");
  };

  const handleOpenFiles = (requestId: string) => {
    setSelectedRequestId(requestId);
    setOpenFiles(true);
  };

  const handleCloseFiles = () => {
    setOpenFiles(false);
    setSelectedRequestId(null);
  };

  return (
    <>
      <PoolList
        {...props}
        bulkActionButtons={false}
        exporter={exporter}
        title={"Old Export Data"}
        filters={filters}
        actions={<ListActions />}
        sort={{ field: "requestDate", order: "DESC" }}
        filterDefaultValues={{ requestedDeliveryDate__gte: moment.utc(new Date()).subtract(6, "months").toISOString() }}
        filter={user?.isCustomer ? { ownerCode__eq: user?.ownerCode } : {}}
      >
        <Datagrid>
          <FunctionField
            label="Files"
            render={(record: any) => (
              <Tooltip title="View Files">
                <IconButton
                  size="small"
                  onClick={e => {
                    e.stopPropagation();
                    handleOpenFiles(record.id);
                  }}
                >
                  <AttachFile fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          />
          <TextField source="refNo" label="Ref No" />
          <TextField source="customerName" label="Customer" />
          <TextField source="customerPO" label="Customer PO" />
          <TextField source="melCategory" label="Requirement Category" />
          <TextField source="acRegistration" label="AC Registration" />
          <TextField source="partNumber" label="Requested Part No" />
          <TextField source="servPartNo" label="Serviceable Part No" />
          <TextField source="servSerialNo" label="Serviceable Serial No" />
          <TextField source="unServPartNo" label="Core Unit Part No" />
          <TextField source="unServSerialNo" label="Core Unit Serial No" />
          <TextField source="destination" label="Destination" />
          <CustomDateField source="requestDate" label="Request Date" showTime />
          <CustomDateField source="requestedDeliveryDate" label="Requested Delivery Date" showTime />
          <TextField source="servicable" label="Serviceable" />
          <TextField source="unServicable" label="Core Unit" />
          <TextField source="unServicableACReg" label="Core Unit AC Reg" />
          <TextField source="shippedOnTime" label="Serviceable Shipped On Time" />
        </Datagrid>
      </PoolList>
      <OldDataFileList
        openFiles={openFiles}
        handleCloseFiles={handleCloseFiles}
        selectedRequestId={selectedRequestId}
      />
    </>
  );
};

export default OldDataExportList;
